import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-container">
          <div>
            <Link to="/" className="footer-logo">
              Opi<span>Tech</span>
            </Link>
            <p className="footer-description">
              We design and develop extraordinary digital experiences that connect brands with their audience. From websites to mobile apps, we create solutions that drive growth and elevate your digital presence.
            </p>
            <div className="footer-social">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>

            </div>
          </div>
          
          <div>
            <h3 className="footer-heading">Navigate</h3>
            <ul className="footer-links">
              <li className="footer-link"><Link to="/">Home</Link></li>
              <li className="footer-link"><Link to="/services">Services</Link></li>
              {/* <li className="footer-link"><Link to="/portfolio">Our Work</Link></li> */}
              <li className="footer-link"><Link to="/about">About Us</Link></li>
              <li className="footer-link"><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="footer-heading">Services</h3>
            <ul className="footer-links">
              <li className="footer-link"><Link to="/services/web-development">Web Development</Link></li>
              <li className="footer-link"><Link to="/services/app-development">Mobile Development</Link></li>
              <li className="footer-link"><Link to="/services/ui-ux-design">UI/UX Design</Link></li>
              <li className="footer-link"><Link to="/services/ecommerce">E-Commerce Solutions</Link></li>
              <li className="footer-link"><Link to="/services/custom-software">Custom Software</Link></li>
            </ul>
          </div>
          
          <div>
            <h3 className="footer-heading">Contact</h3>
            {/* <div className="footer-contact-item">
              <span className="footer-contact-icon"><i className="fas fa-map-marker-alt"></i></span>
              <span>123 Creative Avenue, Dublin 2, Ireland</span>
            </div> */}
            <div className="footer-contact-item">
              <span className="footer-contact-icon"><i className="fas fa-phone"></i></span>
              <span>+353 86 123 9115</span>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-icon"><i className="fas fa-envelope"></i></span>
              <span>info@opitech.ie</span>
            </div>
            <div className="footer-contact-item">
              <span className="footer-contact-icon"><i className="fas fa-clock"></i></span>
              <span>Mon-Fri: 9AM - 6PM</span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="grid grid-2" style={{ gap: '1rem', alignItems: 'center' }}>
            <div>
              <p>&copy; {currentYear} OpiTech. All rights reserved.</p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <Link to="/privacy-policy" style={{ marginRight: '1.5rem', color: 'var(--gray)' }}>Privacy Policy</Link>
              <Link to="/terms-conditions" style={{ color: 'var(--gray)' }}>Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-circle footer-circle-1"></div>
      <div className="footer-circle footer-circle-2"></div>
    </footer>
  );
};

export default Footer;